import {FormField} from "../form-field/form-field";

export class FormFieldToggle extends FormField{
    constructor(scope,$root){
        super(scope,$root);
        this.$check = null;
        this.$input = null;
    }

    getVal(){
        return this.$check.get(0).checked;
    }

    setVal(val,noEvent){
        this.$check.prop("checked",!!val);
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    ready(){
        super.ready();
        this.$check = this.$root.find("[type=checkbox]");
        this.$input = this.$root.find(":input");

        this.$check.on(
            "change",
            (ev) => {
                this.$root.trigger("formField:changeVal",[{sourceEvent:ev}]);
            }
        );
    }
}
